module.exports = __webpack_public_path__ + "static/media/dinner062023.cb080ba8.pdf";